export enum EDITOR_DROPZONE_SIDE_TYPE {
    right = 'right',
    left = 'left',
}
